import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemText, Button, Skeleton, Box } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const VendorApplicationList = ({ applications = [], isLoading }) => (
    <Card sx={{ borderRadius: 3, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <CardContent>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h6" fontWeight={700}>
                    Vendor Applications ({applications.length})
                </Typography>
                <PersonAddIcon color="primary" />
            </Box>

            {isLoading ? (
                [...Array(3)].map((_, i) => <Skeleton key={i} variant="rounded" height={45} sx={{ mb: 1 }} />)
            ) : applications.length > 0 ? (
                <List disablePadding>
                    {applications.slice(0, 5).map((app, i) => (
                        <ListItem key={i} divider button>
                            <ListItemText
                                primary={app.name || 'Unnamed Vendor'}
                                secondary={`${app.email} • ${new Date(app.createdAt).toLocaleDateString()}`}
                            />
                            <Button size="small" variant="outlined" color="primary">
                                View Details
                            </Button>
                        </ListItem>
                    ))}
                </List>
            ) : (
                <Typography align="center" color="text.secondary" py={4}>
                    No new applications needing review.
                </Typography>
            )}
        </CardContent>
    </Card>
);

export default VendorApplicationList;
